<div class="wrapper">
  <div class="item invitees">
    <h2 translate="CALLS.CALL_INFO.INVITEES" [translateParams]="{ count: getInviteeCount(call.groupedAttendees) }"></h2>
    @for (organization of call.groupedAttendees; track organization.organizationName) {
      <div class="organization">
        <h3>{{ organization.organizationName }}</h3>
        @for (attendee of organization.attendees; track attendee.email) {
          <div class="attendee">
            <div class="name">
              {{ attendee.name }}
            </div>
            <div class="status">
              @if (attendee.response === 'ACCEPT') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                  <g fill-rule="evenodd">
                    <path style="fill: #507c5c" d="M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z" />
                    <path fill="#FFF" d="M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z" style="fill: #fff" />
                    <circle style="fill: #87d019" cx="7" cy="7" r="4.3" />
                  </g>
                </svg>
              } @else if (attendee.response === 'TENTATIVE') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                  <g fill-rule="evenodd">
                    <path style="fill: #ffc61b" d="M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z" />
                    <path fill="#FFF" d="M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z" style="fill: #fff" />
                    <circle style="fill: #ffe188" cx="7" cy="7" r="4.3" />
                  </g>
                </svg>
              } @else if (attendee.response === 'DECLINE') {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                  <g fill-rule="evenodd">
                    <path style="fill: #b3404a" d="M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z" />
                    <path fill="#FFF" d="M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z" style="fill: #fff" />
                    <circle style="fill: #fd4958" cx="7" cy="7" r="4.3" />
                  </g>
                </svg>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="item recent-interactions">
    <h2 translate="CALLS.CALL_INFO.RECENT_INTERACTIONS"></h2>
    <div class="interactions">
      @if (call.recentInteractions.length === 0) {
        <div class="no-interactions">
          <p translate="CALLS.CALL_INFO.NO_RECENT_INTERACTIONS"></p>
        </div>
      }
      @for (interaction of call.recentInteractions; track interaction.id) {
        <a [routerLink]="['/app', 'meetings', interaction.id]" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
          <div class="interaction">
            <div class="icon-container">
              <mat-icon [matTooltip]="interaction.provider">
                @if (interaction.provider === 'TEAMS') {
                  groups
                } @else if (interaction.provider === 'ZOOM') {
                  videocam
                } @else if (interaction.provider === 'GMEET') {
                  videocam
                }
              </mat-icon>
            </div>

            <div class="call-name-container">
              {{ interaction.callName }}
            </div>

            <div class="date-and-time-container">
              {{ interaction.date | date }}
            </div>
          </div>
        </a>
      }
    </div>
  </div>

  <div class="item meeting-profile-selection">
    <h2 translate="COMMON.CALL_PROFILE"></h2>
    @if (callProfiles$ | async; as result) {
      @if (result.isSuccess) {
        <app-select
          name="call-profile-id"
          [ngModel]="call.callProfileId"
          (ngModelChange)="updateCallProfile($event)"
          [disabled]="!canEdit"
          labelKey="COMMON.CALL_PROFILE"
          nullValueLabelKey="CALLS.ADMIN.ORGANIZATION_DEFAULT"
          [options]="getCallProfileOptions(result.data)"
        ></app-select>
      }
    }
  </div>
  <div class="item agenda-type-selection">
    <h2 translate="CALLS.AGENDA_TYPE"></h2>
    <mat-form-field>
      <mat-label translate="CALLS.AGENDA_TYPE"></mat-label>
      <mat-select name="agenda-type" [ngModel]="call.agendaType" (ngModelChange)="updateAgendaType($event)" [disabled]="call.isPrevious || !canEdit">
        <mat-option [value]="'SINGLE'">{{ 'CALLS.AGENDA_TYPE_SINGLE' | translate }}</mat-option>
        <mat-option [value]="'MULTIPLE'">{{ 'CALLS.AGENDA_TYPE_MULTIPLE' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="item document-upload-container">
    <h2 translate="CALLS.CALL_INFO.DOCUMENT_UPLOAD.TITLE"></h2>
    <div class="uploaded-documents-container">
      @if (call.userUploadedResources.length > 0) {
        <h3>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.UPLOADED_DOCUMENTS' | translate }}</h3>
      }
      @for (resource of call.userUploadedResources; track $index) {
        <div class="uploaded-document">
          <mat-icon>attach_file</mat-icon>
          <div class="details">
            <div class="file-info">
              <strong>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.' + resource.resourceType | translate }}:</strong>
              {{ resource.fileName }}
            </div>
            <div class="upload-date">{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.UPLOADED' | translate }}: {{ resource.createdAt | date: 'd MMM y' }}</div>
          </div>
          @if (resource.downloadUrl !== null) {
            <mat-icon class="clickable" (click)="downloadResource(resource)" [matTooltip]="'COMMON.DOWNLOAD' | translate">download</mat-icon>
          }
          @if (isAuthorizedToManageDocuments) {
            <mat-icon class="clickable" color="warn" (click)="removeUpload(resource)" [matTooltip]="'COMMON.REMOVE' | translate">delete</mat-icon>
          }
        </div>
      } @empty {
        <p translate="CALLS.CALL_INFO.DOCUMENT_UPLOAD.NO_DOCUMENTS"></p>
      }
    </div>
    @if (isAuthorizedToManageDocuments && missingDocuments.length > 0) {
      <div class="new-upload-container">
        <h3>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.UPLOAD_NEW_DOCUMENT' | translate }}</h3>
        @if (call.agendaType === 'MULTIPLE') {
          <div>
            <mat-icon class="warning-icon">warning</mat-icon>
            <span class="warning-text">{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.MULTI_AGENDA_WARNING' | translate }}</span>
          </div>
        }
        <app-call-document-upload [callId]="call.id" [acceptedDocuments]="missingDocuments"></app-call-document-upload>
      </div>
    }
  </div>
  <div class="item minutes-styling">
    @if (call.haveMinuteStylesBeenUpdatedSinceLastProcessing && canEdit) {
      <div class="warning-container">
        <mat-icon class="warning-icon">warning</mat-icon>
        <div class="warning-content">
          <div class="warning-title">{{ 'CALLS.REPROCESS_OUTPUTS.SETTINGS_CHANGED' | translate }}</div>
          <div class="warning-message">
            {{ 'CALLS.REPROCESS_OUTPUTS.WARNING' | translate }}
            <div class="warning-action">
              <button mat-raised-button (click)="reprocessOutputs()">{{ 'CALLS.REPROCESS_OUTPUTS.TITLE' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    }
    <h2 translate="MINUTES_STYLING.TITLE"></h2>
    <app-minutes-styling
      [namingDisabled]="call.attendeeNames.length === 0"
      [disabled]="!canEdit"
      [data]="call"
      (update)="updateMinutesStyling($event)"
    ></app-minutes-styling>
  </div>
</div>
